//@ts-nocheck
import { Box, ColorOptions, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useState } from 'react'
import BusinessNeeds from '../../comps/BusinessNeeds'
import ContactUs from '../../comps/ContactUs'
import DevCentricProduct from '../../comps/DevCentricProduct'
import { ImageLoopAnimation } from '../../comps/ImageLoopAnimation'
import JioBizzHomeSection from '../../comps/JioBizzHomeSection'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import ProductsHomeSection from '../../comps/ProductsHomeSection'
import { Statistics } from '../../comps/Statistics'
import { WeDoItSection } from '../../comps/WeDoItSection'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import WhyJio from '../WhyJio'
import BestWayToPayOnline from './BestWayToPayOnline'
import { styles } from './styles'

const ImageBusiness = require('../../assets/svg/business.svg')
const ImageDeveloper = require('../../assets/svg/dev.svg')

const PaymentGateway: FC = () => {
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const navigation = useNavigation()

  const merchantsLogo = require('../../assets/images/merchant-logos.png')
  const mop100Plus = require('../../assets/images/mop100plus.png')
  const borderRadius = viewPortWidth > 600 ? 100 : 24

  const [navVisible, setNavVisible] = useState(false)
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  return (
    <Box f={1}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar isBg={true} onPress={handleNav} hamBurgerType="primary" isLightBackground={false} showSignin={true} />
      <Box {...themedStyle.container} h={'calc(100vh - 72px)'} bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}>
        <BestWayToPayOnline />
        {isMobile && <ImageLoopAnimation src={merchantsLogo} />}
        {!isMobile && (
          <Box ph={resPadding} align={'center'}>
            <Image resizeMode={'cover'} source={merchantsLogo} width={'100%'} height={48} />
          </Box>
        )}
        <Box marginHorizontal={resPadding} align={'center'} marginTop={isMobile ? 0 : 80}>
          <Image resizeMode={'center'} source={mop100Plus} width={'100%'} height={isMobile ? 200 : 780} />
          <ModBox position={'absolute'} top={0} bottom={0} left={isMobile ? 24 : 100} justify={'center'}>
            <Text
              title={staticStrings.mops100Plus}
              fontSize={isMobile ? 16 : 48}
              fontFamily={'jiotype-black'}
              lineHeight={isMobile ? 20 : 72}
              color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
            />
          </ModBox>
        </Box>
        <Spacer direction={'vertical'} size={isTab ? 70 : isMobile ? 32 : 90} />
        <Box
          w={'100%'}
          bg={'WHITE'}
          borderTopRightRadius={borderRadius}
          borderTopLeftRadius={borderRadius}
          pv={isMobile ? undefined : 160}
          ph={resPadding}>
          <ProductsHomeSection isMobile={isMobile} isTab={isTab} />
          <JioBizzHomeSection isMobile={isMobile} isTab={isTab} />
          <DevCentricProduct isMobile={isMobile} isTab={isTab} />
          <WhyJio />
          <BusinessNeeds isMobile={isMobile} isTab={isTab} />
          <WeDoItSection isMobile={isMobile} isTab={isTab} />
          <Statistics isMobile={isMobile} isTab={isTab} />
        </Box>
        <Box marginTop={isMobile ? -32 : -120}>
          <ContactUs type={'footer'} />
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentGateway
